import React from "react";
import WidgetContainer from "components/WidgetContainer/WidgetContainer";
import AbsButton from "components/Button/AbsButton";
import ReportFraudLogo from "images/security-page/report-fraud.png";
import DesktopLogo from "images/security-page/fraud-desktop-icon.svg";
import MobileLogo from "images/security-page/fraud-mobile-icon.svg";
import FraudTabElement from "images/security-page/fraud-button-element.svg";

import "./SafetyFraudCard.css";
const SafetyFraudCard = () => {
    return (
        <WidgetContainer stylesClass="fraud-card">
            <div className="fraud-card__content">
                <img
                    src={FraudTabElement}
                    alt=""
                    className="fraudtab-el1"
                    draggable="false"
                />
                <img
                    src={FraudTabElement}
                    alt=""
                    className="fraudtab-el2"
                    draggable="false"
                />
                <div className="fraud-card__content__item fraud-logo">
                    <img src={ReportFraudLogo} alt="" draggable="false" />
                </div>
                <div className="fraud-card__content__item fraud-content">
                    <div className="fraud-content-top">
                        <div className="fraud-app">
                            <img
                                src={MobileLogo}
                                alt=""
                                width="27"
                                draggable="false"
                            />
                            <h2>On your mobile app</h2>
                            <p>
                                Registered PhonePe users can report <br />{" "}
                                suspicious activity on the PhonePe app
                            </p>
                            <div className="fraud-app__list">
                                <div>
                                    <p className="fraud-app__list-circle"></p>
                                    <p>Go to the PhonePe app on your mobile</p>
                                </div>
                                <div>
                                    <p className="fraud-app__list-circle"></p>
                                    <p>
                                        Go to :
                                        <span style={{ fontWeight: "bold" }}>
                                            Help &gt; Account security
                                            issue-Report <br /> Fraudulent
                                            activity &lt;Screenshot&gt;
                                        </span>
                                    </p>
                                </div>
                            </div>
                            <div className="fraud-app__btn">
                                <AbsButton
                                    btnText="Click to report now"
                                    btnStyle="btnStyle"
                                    pagePath="https://phon.pe/help"
                                    btnArrowFlag={false}
                                />
                            </div>
                        </div>
                        <div className="fraud-web">
                            <img
                                src={DesktopLogo}
                                alt=""
                                width="52"
                                draggable="false"
                            />
                            <h2>On the website</h2>
                            <p>
                                Not registered on PhonePe? <br />
                                You can still report an issue! Go to
                            </p>
                            <a href="https://support.phonepe.com/">
                                support.phonepe.com
                            </a>
                        </div>
                    </div>
                    <div className="fraud-content-bottom">
                        <span>
                            Report complaints to the nearest cyber crime center
                            or online at
                        </span>
                        <a href="https://cybercrime.gov.in/">
                            https://cybercrime.gov.in/
                        </a>
                    </div>
                </div>
            </div>
        </WidgetContainer>
    );
};

export default SafetyFraudCard;
